import RefappVideoProvider from './components/base/video-provider.vue';
import RefappPlaylistProvider from './components/base/playlist-provider.vue';
import RefappVideo from './components/refapp-video.vue';
import RefappPlaylist from './components/refapp-playlist.vue';
import RefappVideoTranscript from './components/base/transcript.vue';

import './styles/entry.scss';

export default {
  install(app) {
    const components = [
      RefappVideoProvider,
      RefappPlaylistProvider,
      RefappVideo,
      RefappPlaylist,
      RefappVideoTranscript,
    ];
    components.forEach((c) => app.component(c.name, c));
  },
};
